const $ = $ || jQuery;

export default class FilterDataEvents {

    constructor () {
        this.form = $('.views-exposed-form');
        this.fieldsets = [];
        Drupal.behaviors.userSearch = {
            attach: (context, settings) => {
                this.form = $('.views-exposed-form');
                this.cacheToggle();
                this.controllers();
            }
        }
        
        this.controllers();
        this.onChange = this.onChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.cacheToggle = this.cacheToggle.bind(this);
        
    }

    cacheToggle() {
        console.log(this.fieldsets);
        this.fieldsets.forEach((toggled, i) => {
            this.form.find('.fieldset-wrapper').eq(i)[`${toggled ? 'add' : 'remove'}Class`]('show');
        });
    }

    toggle(e) {
        const el = $(e.currentTarget);
        const content = el.closest('fieldset').find('.fieldset-wrapper');
        const icon = el.find('.fa');
        content[`${content.hasClass('show') ? 'remove' : 'add'}Class`]('show');
        if (icon.hasClass('fa-chevron-down')) {
            icon.removeClass('fa-chevron-down');
            icon.addClass('fa-chevron-up');
        } else {
            icon.removeClass('fa-chevron-up');
            icon.addClass('fa-chevron-down');
        }
        this.fieldsets = [];
        this.form.find('.fieldset-wrapper').each((i, el) => {
            this.fieldsets.push($(el).hasClass('show'));
        });
    }

    onChange() {
        this.form.find('input[type="submit"]').trigger('click');
    }

    controllers() {
        this.form.on('submit', e => e.preventDefault());
        this.form.find('input[type="checkbox"]').off('change');
        this.form.find('input[type="checkbox"]').on('change', this.onChange.bind(this));
        this.form.find('.collapsable_titles').off('click');
        this.form.find('.collapsable_titles').on('click', this.toggle.bind(this));
        this.form.find('input[type="text"]').off('keydown');
        this.form.find('input[type="text"]').on('keydown', e => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.onChange(), 1000);
        });
    }
}


// WEBPACK FOOTER //
// ./modules/FilterDataEvents/index.js